import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function SetupOwner() {
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [message, setMessage] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");

    const createOwner = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setMessage("Passwords do not match.");
            return;
        }

        try {
            setIsCreating(true);
            setMessage("");

            const res = await axios.post(`${API_URL}/auth/register`, {
                name,
                email,
                password,
            });

            localStorage.setItem("token", res.data.token);
            navigate("/");
        } catch (error) {
            setMessage(
                error.response?.data?.message || "Could not create owner account."
            );
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <div style={styles.page}>
            <form onSubmit={createOwner} style={styles.card}>
                <h1>First-Time Setup</h1>
                <p style={styles.subtitle}>
                    Create the owner account for this POS.
                </p>

                {message && <p style={styles.message}>{message}</p>}

                <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Owner full name"
                    style={styles.input}
                    required
                />

                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Owner email"
                    style={styles.input}
                    required
                />

                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Owner password"
                    style={styles.input}
                    required
                />
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm password"
                    style={styles.input}
                    required
                />

                <button type="submit" style={styles.button} disabled={isCreating}>
                    {isCreating ? "Creating..." : "Create Owner Account"}
                </button>

                <button
                    type="button"
                    onClick={() => navigate("/login")}
                    style={styles.secondaryButton}
                >
                    Back to Login
                </button>
            </form>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        background: "#f4f6f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
    },

    card: {
        width: "390px",
        background: "white",
        padding: "28px",
        borderRadius: "16px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    },

    subtitle: {
        color: "#555",
    },

    input: {
        width: "100%",
        padding: "14px",
        marginBottom: "12px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
    },

    button: {
        width: "100%",
        padding: "14px",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
    },

    secondaryButton: {
        width: "100%",
        padding: "14px",
        marginTop: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
        background: "white",
    },

    message: {
        padding: "10px",
        background: "#fff3cd",
        borderRadius: "8px",
        marginBottom: "12px",
    },
};

export default SetupOwner;